import React from "react";

export function scrollRemoteSelectionIntoView(container) {
  const selected = container?.querySelector?.('[data-remote-focused="true"]');
  if (!selected?.scrollIntoView) return false;
  selected.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
  return true;
}

export function useRemoteSelectionScroll(active, focusKey) {
  const containerRef = React.useRef(null);

  React.useEffect(() => {
    if (!active || focusKey === null || focusKey === undefined) return undefined;
    const schedule = window.requestAnimationFrame || ((callback) => window.setTimeout(callback, 0));
    const cancel = window.cancelAnimationFrame || window.clearTimeout;
    const frame = schedule(() => scrollRemoteSelectionIntoView(containerRef.current));
    return () => cancel(frame);
  }, [active, focusKey]);

  return containerRef;
}
